<div class="question-type__text">
  <h1 class="fs__xxl">Net Promoter Score (NPS)</h1>
  <p class="fs__md">
    Measures participant loyalty by asking how likely they are to recommend a product or service on a 0-10 scale. Commonly used for customer satisfaction
    assessments.
  </p>
</div>
